import Platform from '../../../../../libs/utility/Platform';
import { Theme } from '../../../../components/constants';

export default {
    mainContainer: {
        background: Theme.BACKGROUND_PRIMARY,
        width: "100%",
        minHeight: "100vh",
        padding: "35px",
    },
    twoColumn: {
        display: "flex",
        flexDirection: Platform.isMobileView() ? "column" : "row",
        color: Theme.TEXT_PRIMARY_BLACK,
        flexWrap: "wrap",
    },
    leftColumn: {
        display: "flex",
        flexDirection: "column",
        width: Platform.isMobileView() ? "100%" : "55%",
    },
    rightColumn: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: Platform.isMobileView() ? "100%" : "45%",
    },
    loginBox: {
        width: Platform.isMobileView() ? "100%" : "490px",
        marginTop: "10%",
        minHeight: "200px"
    },
}
